import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;

const PublicAccessService = {
  verify: async (password) => {
    const response = await apiService.post("/public-page-access/verify", {
      password,
    });
    return response.data;
  },
};

export default PublicAccessService;
